import { authorizedInstance, publicInstance } from "../config/axios"

/* Public event page (no login) */

export const getEventQr = async (publicUuid) => {
  const response = await publicInstance.get(`/event-qr/${publicUuid}`)
  return response.data
}

// Page-open beacon. Answers 204; the caller treats it as fire-and-forget.
export const logEventQrScan = async ({ publicUuid, ...payload }) => {
  await publicInstance.post(`/event-qr/${publicUuid}/scan`, payload)
}

export const getEventQrPlayerEventsBatchPath = (publicUuid) =>
  `/event-qr/${publicUuid}/player-events/batch`

export const submitEventQrFeedback = async ({ publicUuid, ...payload }) => {
  const response = await publicInstance.post(
    `/event-qr/${publicUuid}/feedback`,
    payload
  )
  return response.data
}

/* Admin */

// Paginated: { data, total, page, offset, perPage }.
export const getEventQrCodes = async ({ page, perPage, search }) => {
  const response = await authorizedInstance.get("/event-qr-codes", {
    params: { page, perPage, search: search || undefined },
  })
  return response.data
}

export const getEventQrCode = async (id) => {
  const response = await authorizedInstance.get(`/event-qr-codes/${id}`)
  return response.data
}

export const getEventQrCodeSummary = async (id) => {
  const response = await authorizedInstance.get(`/event-qr-codes/${id}/summary`)
  return response.data
}

export const createEventQrCode = async (payload) => {
  const response = await authorizedInstance.post("/event-qr-codes", payload)
  return response.data
}

export const updateEventQrCode = async ({ id, ...payload }) => {
  const response = await authorizedInstance.put(
    `/event-qr-codes/${id}`,
    payload
  )
  return response.data
}

export const setEventQrCodeActive = async ({ id, isActive }) => {
  const response = await authorizedInstance.patch(`/event-qr-codes/${id}`, {
    isActive,
  })
  return response.data
}

export const getEventVideos = async () => {
  const response = await authorizedInstance.get("/event-videos")
  return response.data
}

// { status: "ok" | "broken" | "not_embeddable", reason, httpStatus }, checked
// by the API since the browser can't see inside a cross-origin iframe.
export const getEventVideoLinkStatus = async (videoId) => {
  const response = await authorizedInstance.get(
    `/event-videos/${videoId}/link-status`
  )
  return response.data
}

export const createEventVideo = async (payload) => {
  const response = await authorizedInstance.post("/event-videos", payload)
  return response.data
}

export const updateEventVideo = async ({ videoId, ...payload }) => {
  const response = await authorizedInstance.put(
    `/event-videos/${videoId}`,
    payload
  )
  return response.data
}
